export class ValidationManager {
  requiredRules: any[];
  
  constructor(private $form:JQuery) {
    $form.data("validationManager", this);
    this.init();
  }
  
  init():void {
    this.requiredRules = [];
    this.$form.removeData(["validator", "unobtrusiveValidation"]);
    let me = this;
    $.validator.unobtrusive.parse(this.$form);
    $.each(this.$form.validate().settings.rules, function(_, rule) {
      if (rule.required || rule.range) { me.requiredRules.push(rule); }
    });
  }

  public disableRequiredRules(e: Event): JQuery {
    $.each(this.requiredRules, function (_, rule) {
      rule.required = false;
      if (rule.range) {
        rule.range[0] = '0';
      }
    });
    return this.scrollIntoView(e);
  }

  public enableRequiredRules(e: Event): JQuery {
    $.each(this.requiredRules, function (_, rule) {
      rule.required = true;
      if (rule.range) {
        rule.range[0] = '1';
      }
    });
    return this.scrollIntoView(e);
  }
   
  scrollIntoView(e: Event): JQuery {
    const validator = this.$form.validate();
    validator.form();
    if (validator.errorList && validator.errorList.length > 0) {
      e.preventDefault();
      window.toastr["error"]("", window.messages["couldNotSave"]);
      const $el = $(validator.errorList[0].element);
      window.setTimeout(function() {
        $(window).scrollTop($el.offset().top - 200);
        $el.focus();
      }, 1);
      return $el;
    }
  }
}
